<template>
    <div class="hierarchy-component" v-if="labels.length">
        <div class="tabs" v-if="tabs && labels.length > 1">
            <vx-input-group class="custom-input-group">
                <div class="d-flex">
                    <div class="vx-input-group-append flex-grow">
                        <div class="append-text btn-addon">
                            <vs-button
                                    color="primary"
                                    type="border"
                                    v-for="(item,i) in langMap" :key="i"
                                    @click="currentTab = item.key"
                                    class="radiobtn"
                                    style="border-radius: 0"
                                    :class="{selected: currentTab === item.key}">
                                {{item.label}}
                            </vs-button>
                        </div>
                    </div>
                </div>
            </vx-input-group>
            <div class="scroll">
                <div class="vx-row">
                    <div class="vx-col" v-for="(item,i) in langMap" :key="i" v-if="!tabs || currentTab === item.key">
                        <div class="column">
                            <div class="label" v-if="!tabs"><b>{{item.label}}</b></div>
                            <div class="hierarchy">
                                <div class="object-entry" v-for="(label, i) in labels" :key="i">
                                    <div class="name">{{label[item.key]}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    const HierarchyTranslationMap = [
        {key: 'content', label: 'English'},
        {key: 'content_hind', label: 'Hindi'}
    ]
    export default {
        props: {
            tabs: {type: Boolean, default: false},
            cooboAssetId: {type: String, default: ''},
        },
        data() {
            return {
                langMap: HierarchyTranslationMap,
                currentTab: 'content',
                labels: [],
            }
        },
        computed: {},
        mounted() {
            this.getAssetLabels(this.cooboAssetId)
        },
        methods: {
            getAssetLabels(id) {
                if (!id) return;
                const mapLabels = (l) => l.label[0]
                let url = `https://coobo.embibe.com/api/assetlib/labels/${id}`
                try {
                    this.$axios.get(url, {headers: {Authorization: ''}}).then(res => {
                        this.labels = res.data.map(mapLabels);
                    })
                } catch (err) {
                    this.labels = [];
                }

            }
        },
    }
</script>

<style>
    .hierarchy-component {
        color: black;
        font-size: 16px;
        border: 1px solid rgba(0, 0, 0, 0.24);
        overflow: hidden;
        border-radius: 5px;
        flex-shrink: 0;
    }

    .hierarchy-component h4 {
        background: rgba(var(--vs-dark), 1) !important;
        padding: 5px;
        color: white;

    }

    .hierarchy-component .tabs {
        padding: 5px;
    }

    .hierarchy-component .column {
        padding: 5px 7px 0 7px;
    }

    .hierarchy-component .children {
        padding-left: 15px;
    }
    .hierarchy-component .scroll {
        max-height: 100px;
        overflow: auto;
        overflow-x: hidden;
    }
</style>
